import type { Reminder } from '@/core/domain';
import type { ReminderRepository } from '../repositories/reminder-repository';

export class CreateReminderUseCase {
  constructor(private readonly repository: ReminderRepository) {}

  async execute(reminder: Reminder): Promise<Reminder> {
    return this.repository.create(reminder);
  }
}
